/* eslint-disable @typescript-eslint/no-explicit-any */
import { EntityBaseApiService } from '~packages/json-api/client';
import { IOptions } from '~packages/json-api/client/services/__modules/RestStandardModuleApiService';

export interface Filters {
  [key: string]: string | string[] | number | number[] | boolean;
}

export type Params = Record<string, any>;

interface FilterParams {
  [key: string]: string;
}

/**
 * Метод позволяет применить фильтры в query параметрах без обработки
 * Может принимать примитивы и массивы
 */
export async function getFilteredData(
  apiService: EntityBaseApiService,
  filters: Filters,
  params: Params,
  options: IOptions = {},
  fetchDataObject = {},
  pathBase = apiService.pathFetchAll
) {
  const filterParams: FilterParams = {};
  Object.entries(filters).forEach(([key, value]) => {
    const valueStr = String(value);
    if (!(valueStr[0] === '`')) {
      value = JSON.stringify(value);
    }
    filterParams[key] = valueStr;
  });

  const queryFilterParams: string[] = [];
  Object.entries(filterParams).forEach(([key, val]) =>
    queryFilterParams.push(`${key}=${val}`)
  );

  const queryParams = new URLSearchParams(params).toString();
  const queryParamsString = queryFilterParams.join('&');

  let path = pathBase + '?';
  if (queryParamsString) {
    path += `${queryParamsString}&`;
  }
  if (queryParams) {
    path += queryParams;
  }

  options = Object.keys(options).length
    ? options
    : { method: apiService.requestMethodFetchAll };
  fetchDataObject = Object.keys(fetchDataObject).length
    ? fetchDataObject
    : { method: 'fetchAll' };

  return await apiService._sendRequest(path, null, options, fetchDataObject);
}
